import { ClassicPreset } from 'rete';
import { EventData } from '../../models/event-data';
import { Socket } from '../../models/socket';
import { ConnectionEvents } from './connection-events';

/**
 * Represente une connexion entre 2 noeuds pour le framework RETE (utilisé pour modéliser les évènements du workflow).
 */
export class SelectableConnection extends ClassicPreset.Connection<ClassicPreset.Node, ClassicPreset.Node> {
    /**
     * Valeur indiquant si la connexion est sélectionné.
     */
    selected?: boolean;

    /**
     * Valeur indiquant si la connexion est visible.
     */
    visible: boolean = true;

    /**
     * Emis lorsque l'utilisateur clique sur la connexion.
     */
    public clicked: (connection: SelectableConnection, selected: boolean) => void;

    /**
     * Constructeur de la connection.
     * @param source : Noeud utilisé comme source de la connexion (il peut s'agir d'un trigger ou d'une étape)
     * @param sourceOutput : Socket de sortie du noeud utilisé comme source de la connexion (dans le cas d'un trigger elle est unique dans ce cas il faut utiliser la socket nommée 'output' sinon il faut spécifier le nom de la socket).
     * @param target : Noeud utilisé comme destination de la connexion (il peut s'agir d'une action ou d'une étape)
     * @param targetInput : Socket d'entrée du noeud utilisé comme destination de la connexion (dans le cas d'une action elle est unique dans ce cas il faut utiliser la socket nommée 'input' sinon il faut spécifier le nom de la socket).
     * @param workflowEventData : Données de l'évènement de workflow.
     * @param callBack : Fonction utilisée pour gerer les actions effectuées sur la connexion (comme sa selection ou sa desselection).
     */
    constructor(
        source: ClassicPreset.Node,
        public sourceSocket: Socket,
        target: ClassicPreset.Node,
        public targetSocket: Socket,
        public eventId: number,
        public workflowEventData: EventData,
        public callBack: (id: string, data: ConnectionEvents) => void
    ) {
        super(source, sourceSocket.code, target, targetSocket.code);
        // Seules les données seront accessible au moment de la sauvegarde de la connection -> on stocke l'id de l'évènement dedans.
        workflowEventData.id = eventId;
    }
}
